import paths from "~/constants/paths";

export default defineNuxtRouteMiddleware((to) => {
  const { $features } = useNuxtApp();

  const router = useRouter();

  if (!$features?.bundles?.is_enabled && to.path === paths.bundles) {
    return navigateTo(paths.home);
  }
});
